// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"

// Show progress bar sooner (default 500ms)
Turbo.config.drive.progressBarDelay = 200

import { configure as configureLexxy } from "@37signals/lexxy"
// Chat composer: a bare box, no toolbar. Attachments stay on ONLY so the
// @mention prompt works (mentions are action-text attachments); real files
// are blocked from the editor and go through the chat form instead.
// Attachments must stay on for the @mention prompt (mentions are
// action-text attachments). Real files are rejected inside the editor by a
// lexxy:file-accept handler (see chat_composer_controller) and go up through
// the chat form as their own messages instead.
configureLexxy({ chat: { toolbar: false, attachments: true } })

// Chat presence: who is online, for the people list.
import { startAppearance } from "./chat/appearance"
document.addEventListener("DOMContentLoaded", startAppearance, { once: true })
import "@rails/actiontext"
